import React, { Fragment, useEffect, useState } from 'react';
import { array, string } from 'prop-types';
import './styles.scss';

const Carousel = ({ displayImages, titles, subtitles, links, size = 'full', backgroundSize = ['cover'] }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const intervalID = setInterval(
      () => {
        if (currentImageIndex < displayImages.length - 1) {
          setCurrentImageIndex(currentImageIndex + 1);
        } else {
          setCurrentImageIndex(0);
        }
      },
      6000);

    return () => { clearInterval(intervalID) };
  });


  const imageStyle = {
    backgroundImage: "url('" + displayImages[currentImageIndex] + "')",
    backgroundSize: backgroundSize[currentImageIndex],
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  };
  return (
    <>
      <div className={`animation ${size}-img cursorPointer`} style={imageStyle}> </div>
      <div className="dots">
        {
          displayImages.map((image, index) => (
            (index === currentImageIndex) ?
              (<Fragment key={image}>
                <button type="button" onClick={() => setCurrentImageIndex(index)} className="carousel-dot" aria-label={`Ir al slide ${index + 1}`} aria-current="true"><i className="bi bi-circle-fill"></i></button>{"  "}
              </Fragment>)
              :
              (<Fragment key={image}>
                <button type="button" onClick={() => setCurrentImageIndex(index)} className="carousel-dot" aria-label={`Ir al slide ${index + 1}`}><i className="bi bi-circle"></i></button>{"  "}
              </Fragment>)
          ))
        }
      </div>
      <div className="img-text" >
        <h2 className="title"> {titles[currentImageIndex]} </h2>
        <p className="legend"> {subtitles[currentImageIndex]} </p>
      </div>
    </>
  );
}

Carousel.propTypes = {
  displayImages: array.isRequired,
  titles: array.isRequired,
  subtitles: array.isRequired,
  size: string.isRequired,
  backgroundSize: array.isRequired
};



export default Carousel;
